import styled from 'styled-components';

export const ThingsYouShouldKnowWrapper = styled.div(
  props => `
    background-color: ${props.theme.colors.goYellow.light};
    align-items: center;
    padding: ${props.theme.spacing.large};
    border-radius: ${props.theme.misc.borderRadius.xxxlarge};
    margin: 0;   
  `,
);

export const TitleOuterWrapper = styled.div(
  props => `
    display:flex; 
    align-items:center;
  `,
);

export const TitleWrap = styled.div(
  props => `
    display:flex;
    font-size:${props.theme.font.custom(16)};
    
    font-weight:bold;
    font-family:${props.theme.font.fontFamily};
    margin-left: ${props.theme.spacing.base};

  `,
);

export const ThingsListItem = styled.ul(
  props => `
    list-style-type:disc;
    margin: ${props.theme.spacing.large} 0 0 ${props.theme.spacing.large} ;
> li{
    color:${props.theme.colors.goRed.base};
}

  `,
);

export const CheckBoxEntryWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  padding-top:${props.theme.spacing.base};


`,
);

export const TitleTxtWrapSpan = styled.span(
  props => `

  font-size:${props.theme.spacing.custom(14)};
  color:${props.theme.colors.downriver.base};

`,
);
